import React, { useState } from "react"
import { Modal, Columns, Button, Header } from "components/elements"
import CustomDateOfBirthPicker from "components/auth/register/birthdate/birthdate"
import { Subscribe } from 'unstated'
import AppContainer from "components/context/AppContainer"
import * as Yup from 'yup'
import Cookies from "js-cookie"

const basicValidationSchema = Yup.object().shape({
  birthDate: Yup.string()
  .nullable()
  .required('Birth Date is required.')
})

const BirthDateModal = (props) => {
  const { openBirthDateModal } = props
  const [basicValues, setBasicValues] = useState({ birthDate: null })
  const [basicErrors, setBasicErrors] = useState({ birthDate: null })

  const handleSubmit = (event, auth) => {
    event.preventDefault()
    basicValidationSchema
    .validate(
      {
        birthDate: basicValues.birthDate,
      },
      { abortEarly: false }
    )
    .then(
      function(responseData) {
        Cookies.set('userBirthDate', basicValues.birthDate)
        props.onModalClose(basicValues.birthDate)
      }
    )
    .catch(
      function(responseData) {
        setBasicErrors({
          birthDate: responseData.inner[0]['message']
        })
      }
    )
  }

  const handleModalClose = () => {
    props.onModalClose(basicValues)
  }

  const handleDateChange = (field, value) => {
    setBasicValues({ [field]: value })
    setBasicErrors({ [field]: null  })
  }

  return (
    <Modal
      closeOnEsc={false}
      closeOnBlur={false}
      showClose={true}
      show={openBirthDateModal}
      onClose={handleModalClose}
      mobileAnimation={'up'}
      contentClassName="birthdate-modal-content"
      size="auto"
      mobileHeight="auto"
    >
      <Subscribe to={[AppContainer]}>
        {(auth) => {
          return (
            <React.Fragment>
              <div className="has-text-centered">
                <Header
                  renderas="h2"
                  size={4}
                  className="has-text-weight-extra-bold mt-2 mb-5"
                >
                  Enter Birth Date
                </Header>
              </div>
              <form onSubmit={(e) => handleSubmit(e, auth)}>
                <Columns>
                  <Columns.Column>
                    <CustomDateOfBirthPicker
                      onChange={handleDateChange}
                      basicValues={basicValues}
                      basicErrors={basicErrors}
                    />
                  </Columns.Column>
                </Columns>
                <Columns>
                  <Columns.Column>
                    <div className='has-text-centered'>
                      <Button
                        size="small"
                        color="primary"
                        className="mt-4"
                        onClick={(e) => handleSubmit(e, auth)}
                      >
                        Continue
                      </Button>
                    </div>
                  </Columns.Column>
                </Columns>
              </form>
            </React.Fragment>
          )
        }}
      </Subscribe>
    </Modal>
  )
}
 
export default BirthDateModal